import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { baseUrl } from '../consts/consts'
import Page from '../Components/Page'
import '../assets/css/style.css'

function Dashboard({ Night, SetNight }) {
  const [DataFetched, SetFetch] = useState(false)
  const [dashboard, setDashboard] = useState([])
  const [error, setError] = useState('')
  const [FormShown, ShowForm] = useState(false)
  const [teacherLoader, setTeacherLoader] = useState(false)
  const [paginationData, setPaginationData] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')
  const [loader, setLoader] = useState(false)

  const fetchTeacherData = async (filters = '', page = 1) => {
    setTeacherLoader(true)
    try {
      const filterString = filters ? '&' + filters : ''
      const { data } = await axios.get(
        `${baseUrl}/teachers?page=${page}${filterString}`
      )

      let updatedData = []

      if (data.data.collection.length > 0) {
        data.data.collection.forEach((teacher) => {
          const obj = {
            ...teacher,
            availablity: teacher.availablity?.split(','),
            time_slot: teacher.time_slot?.split(','),
          }
          updatedData.push(obj)
        })
      }

      setDashboard(updatedData)
      setPaginationData(data.data.pagination)
      SetFetch(true)
      setTeacherLoader(false)
    } catch (error) {
      SetFetch(true)
      setTeacherLoader(false)
      setError('Some error occured please try after some time.')
    }
  }
  useEffect(() => {
    if (!DataFetched) {
      fetchTeacherData()
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {}, [dashboard])
  useEffect(() => {}, [ShowForm])

  const formSubmitHandler = async (userInputData) => {
    const formData = new FormData()

    formData.append('user_name', userInputData.user_name)
    formData.append('user_email', userInputData.user_email)
    if (userInputData.job_type === 'Other') {
      formData.append('job_type', userInputData.job_type_other)
    } else {
      formData.append('job_type', userInputData.job_type)
    }
    formData.append('teaching_mode', userInputData.teaching_mode)

    if (userInputData.availability.length > 0) {
      for (let i = 0; i < userInputData.availability.length; i++) {
        formData.append(`availablity[${i}]`, userInputData.availability[i])
      }
    } else {
      setError('Please select availability')
    }

    if (userInputData.time_slot.length > 0) {
      for (let i = 0; i < userInputData.time_slot.length; i++) {
        formData.append(`time_slot[${i}]`, userInputData.time_slot[i])
      }
    } else {
      setError('Please select time slot')
    }

    if (userInputData.expertise === 'Other') {
      formData.append('expertise', userInputData.expertise_other)
    } else {
      formData.append('expertise', userInputData.expertise)
    }
    formData.append('experience', userInputData.experience)
    formData.append('feedback', userInputData.feedback)
    formData.append('mobile_no', userInputData.mobile_no)
    formData.append('emirates', userInputData.emirates)
    formData.append('uploaded_cv', userInputData.uploaded_cv)
    formData.append('profile_pic', userInputData.profile_pic)
    
    setLoader(true)
    try {
      const { data } = await axios.post(`${baseUrl}/teacher/add`, formData)
      if (data.error) {
        setError(data.message)
        setLoader(false)
        return
      }
      setError('')
      ShowForm(false)
      setLoader(false)
      await fetchTeacherData()
      setSuccessMessage(
        'Your profile is submitted for the review, please check your email for the result'
      )
    } catch (error) {
      setLoader(false)
      alert('Some error occured please try again')
    }
  }

  const applyfilterHandler = async (filters = {}, page) => {
    const { search, filters: filter } = filters
    let job_type = filter['Job Type'].map((f) => f.selected && f.name).filter(f => f).join(',')
    let mode = filter['Mode'].map((f) => f.selected && f.name).filter(f => f).join(',')
    let availability = filter['Availability'].map((f) => f.selected && f.name).filter(f => f).join(',')
    let time_slot = filter['Time Slot'].map((f) => f.selected && f.name).filter(f => f).join(',')
    let emirates = filter['Emirates'].map((f) => f.selected && f.name).filter(f => f).join(',')

    let filterString = `search=${search}&job_type=${job_type}&mode=${mode}&availability=${availability}&time_slot=${time_slot}&emirates=${emirates}`

    fetchTeacherData(filterString, page)
  }

  return (
    <Page
      Night={Night}
      SetNight={SetNight}
      Header={'Pristia'}
      Data={dashboard}
      teachers={dashboard}
      ListName='List of teachers'
      formSubmitHandler={formSubmitHandler}
      ActionName='Guest Lecture'
      error={error}
      ShowForm={ShowForm}
      FormShown={FormShown}
      loader={loader}
      teacherLoader={teacherLoader}
      fetchTeacherData={fetchTeacherData}
      paginationData={paginationData}
      successMessage={successMessage}
      setSuccessMessage={setSuccessMessage}
      applyFilter={applyfilterHandler}
    />
  )
}
export default Dashboard
